import {EWASTE_API_PATHS} from "../constants/EWasteApiPaths";
import {callEWasteSearchApi} from "./EWasteApiHelper";

const metricProcessName = "SCC_EWASTE_CONTAINER_SEARCH";
const SUB_PROCESS = "searchEWasteContainers";

export async function searchEWasteContainers(siteName, {
    from = 0,
    size = 50,
    queryFilters = [],
    sortInfos = []
} = {}) {
    return callEWasteSearchApi(
        EWASTE_API_PATHS.SEARCH_CONTAINERS,
        {siteName, from, size, queryFilters, sortInfos},
        metricProcessName,
        SUB_PROCESS
    );
}



// WEBPACK FOOTER //
// ./src/commons/api/SearchEWasteContainers.js